import React from "react";

interface SvgProps {
  classa: string;
  fill?: string;
  style?: object;
}

const SvgIcon: React.FC<SvgProps> = ({
  classa,
  fill = "currentColor",
  style = {},
}: SvgProps) => {
  return (
    <i aria-hidden="true" className="anticon">
      <svg
        className="inline-block overflow-hidden text-base w-4 h-4"
        style={style}
      >
        <use xlinkHref={"#icon-" + classa} fill={fill} />
      </svg>
    </i>
  );
};

export default SvgIcon;
